import React from 'react'

/* Atoms */
import Box from 'components_new/atoms/Box'

/* Organisms */
import EditableText from 'components_new/organisms/Widget/WidgetHeader/EditableText'

/* Types */
import {
  InnerWidgetPatchBody,
  TCoreWidget,
  TextAlign,
  TextVerticalAlign
} from 'types/GlobalWidget'

const TEXT_ALIGN_TO_JUSTIFY: Record<TextAlign, string> = {
  [TextAlign.LEFT]: 'flex-start',
  [TextAlign.CENTER]: 'center',
  [TextAlign.RIGHT]: 'flex-end'
}

const TEXT_VERTICAL_ALIGN_TO_JUSTIFY: Record<TextVerticalAlign, string> = {
  [TextVerticalAlign.TOP]: 'flex-start',
  [TextVerticalAlign.CENTER]: 'center',
  [TextVerticalAlign.BOTTOM]: 'flex-end'
}

interface TextProps {
  editMode: boolean
  scaleFactor: number
  updateWidget: (id: string, body: InnerWidgetPatchBody) => void
  widget: TCoreWidget
}

const Text = (props: TextProps) => {
  const { editMode, scaleFactor, updateWidget, widget } = props

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent:
          TEXT_VERTICAL_ALIGN_TO_JUSTIFY[widget.text_vertical_align]
      }}
    >
      <Box
        sx={{
          fontSize: 20 * scaleFactor,
          width: '100%',
          display: 'flex',
          color: 'text.primary',
          alignItems: 'center',
          justifyContent: TEXT_ALIGN_TO_JUSTIFY[widget.text_align]
        }}
      >
        <EditableText
          allowTextOverflow={true}
          disabled={!editMode}
          onSubmit={(value) => {
            updateWidget(widget.id, { title: value })
          }}
          scaleFactor={scaleFactor}
          textAlign={widget.text_align}
          value={widget.title}
          variant="title"
        />
      </Box>
    </Box>
  )
}

export default Text
